// Single source of truth for chat-list row dimensions, shared between the MUI
// `chat-item` Button variant (App/theme.ts) and the virtualizer's fixed-size
// estimates (RecentChatsSection). The rows have explicit heights (not measured),
// so the virtualizer treats these as exact — keeping the numbers in one place is
// what stops its offset math from silently drifting when a row style changes.
//
// If a row ever needs a content-driven height, switch the virtualizer to
// `measureElement` instead of adding a second copy of these constants.

/** Height of a single chat row (the `chat-item` Button), in px. */
export const CHAT_ITEM_HEIGHT = 32;

/** Vertical gap baked into each chat row's virtual slot so rows don't touch, in px. */
const CHAT_ROW_GAP = 2;

/** Full virtual-slot height of a chat row: the button plus its inter-row gap. */
export const CHAT_ROW_HEIGHT = CHAT_ITEM_HEIGHT + CHAT_ROW_GAP;

/** Height of a group-header row ("Starred" / "Recents"), in px. */
export const CHAT_HEADER_HEIGHT = 24;

/**
 * Extra space added above a group header that follows another group, in px.
 * Matches the `.topNavButtons` gap above the first (Starred) header so the space
 * above every group header reads the same.
 */
export const CHAT_GROUP_GAP = 8;
